import { NOTIFICATION_TYPES } from 'constants/index'

// Palette for the notification type chips. Keys are matched by a "family"
// prefix so related types share a hue (all post-* are amber, chat-* are blue…).
const FAMILY_COLORS = {
  announcement: { bg: '#ede9fe', fg: '#6d28d9' }, // violet
  chat: { bg: '#e0f2fe', fg: '#0369a1' }, // blue
  group: { bg: '#e0f2fe', fg: '#0369a1' },
  post: { bg: '#fef3c7', fg: '#b45309' }, // amber
  comment: { bg: '#dcfce7', fg: '#15803d' }, // green
  favorite: { bg: '#fce7f3', fg: '#be185d' }, // pink
  qa: { bg: '#e0e7ff', fg: '#4338ca' } // indigo
}

const DEFAULT_COLOR = { bg: '#f1f5f9', fg: '#475569' } // slate

const LABEL_BY_VALUE = new Map(NOTIFICATION_TYPES.map((t) => [t.value, t.label]))

// Turns "post-created" → "Post Created" as a fallback label.
const titleCase = (value) =>
  String(value || '')
    .split(/[-_]/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ')

export const getTypeLabel = (value) => LABEL_BY_VALUE.get(value) || titleCase(value) || '—'

export const getTypeColor = (value) => {
  const family = String(value || '').split('-')[0]
  return FAMILY_COLORS[family] || DEFAULT_COLOR
}

export const maskToken = (token) => (token ? `••••${token.slice(-6)}` : '—')
